import {all, race, take, select, delay, put} from 'redux-saga/effects';
import {stringify} from 'querystring';
import {moment, config} from 'helpers';
import {watchableCalendars} from 'store/google-calendar';
import {user} from 'store/session';

export function* channel() {
  yield all(['GOOGLE_CALENDAR_LIST_RECEIVED']);

  const userId = (yield select(user)).id;
  const expirations = [];
  const ttl = 5*60; //seconds

  while (true) {
    const calendars = yield select(watchableCalendars);
    expirations.length = 0;
    expirations.push(ttl);

    for (const { id, channel } of calendars) {

      const now = moment().unix();
      if (!channel || channel.expiration - now <= 0) {
        try {
          const { result } = yield window.gapi.client.calendar.events.watch({
            address: `https://${config.domain}/watch`,
            calendarId: id,
            id: now,
            params: { ttl },
            type: 'webhook',
            token: stringify({
              calendarId: id,
              channelId: now,
              deviceId: config.deviceId,
              userId,
            }),
          });
          yield put({
            type: 'GOOGLE_CALENDAR_CHANNEL_ESTABLISHED',
            calendarId: id,
            channel: {
              ...result,
              expiration: result.expiration/1000,
            }
          });
        } catch (error) {
          yield put({
            type: 'UI_ERROR',
            error,
          });
        }
        yield delay(500);
      } else {
        expirations.push(channel.expiration - now);
      }
    }

    yield race({
      delay: delay(Math.min.apply(null, expirations)*1000 + 1000),
      force: take('GOOGLE_CALENDAR_READ'),
    });
  }
}
